import React from "react";
import { tt } from "../../../../utils/i18n/i18n";
import MobileDashboardHeader from "../../../Layout/Mobile/MobileDashboardHeader";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import { FormikFormWrapperForJetpackConfig } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import SettingsForm from "./SettingsForm";

export default function () {
  return (
    <div className="d-flex flex-column h-100 dashboard-v2">
      <MobileDashboardHeader title={tt("onboarding_settings")} />
      <div className="px-4 pt-5 mb-4 w-100 d-none d-lg-flex">
        <div className="flex-grow-1">
          <KC_Heading2 text={tt("onboarding_settings")} />
        </div>
        <div className="d-flex gap-sm"></div>
      </div>
      <div className="flex-grow-1">
        <FormikFormWrapperForJetpackConfig ChildComponent={SettingsForm} />
      </div>
    </div>
  );
}
